import { useQueries } from '@tanstack/react-query'

import { FilteractionObject, YesObject } from '@yes.technology/react-toolkit'

import { fetchFilteraction } from 'filteraction/FilteractionResolver'

import { MenuType } from 'site/shared/types/toparea.type'

import { fetchYesObjectsWithFilteraction } from 'yesObject/shared/api/fetchYesObjectsWithFilteraction'

const defaultFetchFilteractionResult = async (
  filteractionId: string
): Promise<Pick<YesObject, 'des' | 'complement'>[] | null> => {
  const filteraction: FilteractionObject | undefined = await fetchFilteraction(
    filteractionId,
    false
  )

  if (!filteraction) {
    return null
  }

  const { objects } = await fetchYesObjectsWithFilteraction({
    filteraction,
    orderby: [
      {
        date_creation_row: 'asc' // temporary classification (sort) ;)
      }
    ]
  })

  return objects
}

type useFetchMenusProps = {
  menus: MenuType[]
  fetchFilteractionResult?: typeof defaultFetchFilteractionResult
}

const useFetchMenus = ({
  menus,
  fetchFilteractionResult = defaultFetchFilteractionResult
}: useFetchMenusProps) => {
  const result = useQueries({
    queries: menus.map(({ filteraction }) => ({
      queryKey: ['filteraction-result', filteraction],
      enabled: !!filteraction,
      queryFn: async () => {
        if (!filteraction) return null

        return fetchFilteractionResult(filteraction)
      }
    })),
    combine: (results) => {
      const menusWithFilteraction = menus.every(
        ({ filteraction }) => !!filteraction
      )

      return menus.map((menu, menuIndex) => {
        const getMenuItems = () => {
          if (!menusWithFilteraction && menu.url) {
            return menu.url?.map((url) => ({
              label: url.des,
              href: url.complement,
              items: []
            }))
          }

          return (results[menuIndex].data || []).map((url) => ({
            label: url.des,
            href: url.complement,
            items: []
          }))
        }

        return {
          label: menu.des,
          href: '',
          items: getMenuItems()
        }
      })
    }
  })

  return result
}

export default useFetchMenus
